import {FC, useState, useEffect} from 'react'
import {showSwal} from '../../../../ui-kit'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col, Image, Button} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {ListAgreementTable} from './components/ListAgreementTable'
import {exportAllAgreements, getAllAgreements} from './core/_requests'

import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {ListAgreementResultRow} from './core/_models'
import {Link} from 'react-router-dom'

const TradeDataAgreementPage: FC = () => {
  const intl = useIntl()
  const axiosPrivate = useAxiosPrivate()
  const [isLoadingAgreement, setIsLoadingAgreement] = useState(false)
  const [selectedYear, setSelectedYear] = useState(null)
  const [listAgreementTableData, setListAgreementTableData] =
    useState<Array<ListAgreementResultRow> | null>()

  const [countData, setCountData] = useState(0)
  const fetchListAgreement = () => {
    setIsLoadingAgreement(true)

    getAllAgreements(axiosPrivate)
      .then((res) => {
        if (res.data.count > 0) {
          setCountData(res.data.count)
          setListAgreementTableData(res.data.table_data)
        }
      })
      .catch((e) => {
        console.error(e)
        setIsLoadingAgreement(false)
      })
      .finally(() => {
        setIsLoadingAgreement(false)
      })
  }

  useEffect(() => {
    fetchListAgreement()
  }, [])

  const [isExporting, setIsExporting] = useState(false)
  const [exportProgress, setExportProgress] = useState(0)
  const [exportMessage, setExportMessage] = useState('Exporting data')

  useEffect(() => {
    let interval
    if (isExporting) {
      interval = setInterval(() => {
        setExportMessage((prev) => {
          if (prev.endsWith('...')) return 'Exporting data'
          return prev + '.'
        })
      }, 500)
    }

    return () => clearInterval(interval)
  }, [isExporting])

  const handleDownloadAgreements = () => {
    setIsExporting(true)

    exportAllAgreements(axiosPrivate)
      .then((res) => {
        const blob = new Blob([res.data], {type: 'text/csv'})

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = 'all_trade_agreements_full_export.csv'

        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        showSwal('Export Complete', undefined, 'success')
      })
      .catch((e) => {
        const resError = e.response
        showSwal('Error', resError?.data?.message || 'Export failed', 'error')
      })
      .finally(() => {
        setIsExporting(false)
      })
  }

  return (
    <>
      {isExporting && (
        <div className='sync-overlay'>
          <div className='sync-box'>
            <h4>{exportMessage}</h4>
            <p>
              This export process may take a few minutes, during which the system will be
              temporarily unavailable.
            </p>
          </div>
        </div>
      )}
      <PageTitle
        breadcrumbs={[
          {
            title: 'Home',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        {intl.formatMessage({id: 'MENU.TRADE_DATA_AGREEMENT'})}
      </PageTitle>
      <Row className='mb-5'>
        <Col>
          <Card className='card-custom card-border'>
            <Card.Body className='d-flex justify-content-around align-items-center'>
              <Image src='/media/tina/img-result-documents.jpg' thumbnail width={110} />
              <div className='ms-5 d-flex flex-column justify-content-center'>
                <h3 className='text-primary'>Trade Data Agreement</h3>
                <div className='text-gray-700'>
                  Manage and explore the comprehensive list of Trade Agreements. This page allows
                  you to view existing agreements, add new entries, update details, or delete
                  obsolete records. You can also easily find specific data using filters and search,
                  and export the complete list for your records. Click the detail (
                  <span className='fa fa-eye text-primary'></span>) for more detail about the
                  agreement.
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className='mb-5'>
        <Col>
          <Card>
            <Card.Header className='card-header-stretch'>
              <Card.Title className='w-100'>
                <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                  <div className='title d-flex align-items-center'>
                    <span className='fa fa-file-alt px-2'></span>
                    <h3 className='text-gray-700'>List Agreements</h3>
                  </div>
                  <div className='header-action'>
                    <Button
                      variant='outline-primary'
                      onClick={() => {
                        handleDownloadAgreements()
                      }}
                    >
                      <span className='fa fa-download px-2'></span>
                      Export CSV
                    </Button>
                    <Link
                      to={'/agreement/add'}
                      className='btn btn-primary d-flex gap-4 align-items-center'
                    >
                      <span className='fa fa-plus'></span>
                      Add
                    </Link>
                  </div>
                </div>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <ListAgreementTable rows={listAgreementTableData} isLoading={isLoadingAgreement} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default TradeDataAgreementPage
